exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saveAndContinueButton__button___1_Afn {\n  background: none;\n  border: none;\n  padding: 0 10px;\n  height: 50px;\n  color: #8e8e8e;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  transition: color 200ms; }\n  .saveAndContinueButton__button___1_Afn:hover:not(:disabled) {\n    color: #3f3f3f; }\n  .saveAndContinueButton__button___1_Afn:disabled {\n    cursor: not-allowed;\n    opacity: 0.5; }\n  @media (max-width: 576px) {\n    .saveAndContinueButton__button___1_Afn {\n      height: 100%;\n      width: 100%;\n      padding: 0 6px;\n      font-size: 13px;\n      background-color: white; } }\n", ""]);

// exports
exports.locals = {
	"button": "saveAndContinueButton__button___1_Afn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdFormPage/StepFooter/SaveAndContinueButton/saveAndContinueButton.scss
// module id = 4670
// module chunks = 6